"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const libs_utils_1 = require("@hotelplan/libs.utils");
const TransferInfo = ({ price, transferIncluded, }) => {
    const [t] = (0, next_i18next_1.useTranslation)(['common', 'srl', 'orl']);
    const transferPart = (react_1.default.createElement("span", { className: "transfer" }, transferIncluded
        ? t('orl:offer.transferIncluded')
        : t('orl:offer.transfer')));
    const pricePart = !transferIncluded && (react_1.default.createElement("span", { className: "price" }, `${t('common:priceFrom')} ${(0, libs_utils_1.formatPrice)(price)} ${t('common:transfer.perPerson')}`));
    return (react_1.default.createElement("p", null,
        transferPart,
        " ",
        pricePart));
};
exports.default = TransferInfo;
//# sourceMappingURL=TransferInfo.js.map